import React from 'react'
import { TEMPLATE_STATUS, TemplateStatus } from '../../../../domain/entities/TemplateStatus'

interface TemplateStatusFilterProps {
    activeStatus?: TemplateStatus
    onStatusChange: (status?: TemplateStatus) => void
}

const STATUS_FILTERS: { value: TemplateStatus; label: string }[] = [
    { value: TEMPLATE_STATUS.ACTIVE, label: 'Activas' },
    { value: TEMPLATE_STATUS.DRAFT, label: 'Borradores' },
    { value: TEMPLATE_STATUS.DEACTIVATED, label: 'Desactivadas' },
]

export function TemplateStatusFilter({ activeStatus, onStatusChange }: TemplateStatusFilterProps) {
    const handleClick = (status: TemplateStatus) => {
        onStatusChange(activeStatus === status ? undefined : status)
    }

    return (
        <div className="flex gap-2 shrink-0">
            {STATUS_FILTERS.map(({ value, label }) => {
                const isActive = activeStatus === value
                return (
                    <button
                        key={value}
                        type="button"
                        onClick={() => handleClick(value)}
                        aria-pressed={isActive}
                        className={`h-9 px-4 py-2 rounded-full text-sm font-normal leading-[18px] border transition-colors ${
                            isActive
                                ? 'bg-gray-800 text-white border-gray-800'
                                : 'bg-white text-[#3E5060] border-[#CBD5E1] hover:bg-gray-50'
                        }`}
                    >
                        {label}
                    </button>
                )
            })}
        </div>
    )
}
